import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { WeightConversionPipe } from "app/main/shared/pipes/weight-conversion.pipe";
import { BoxesDataService } from "app/main/shared/services/boxes-data.service";
import { findBox } from "app/main/shared/ts/utilityFn";
import { Subject, Subscription } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

@Component({
  selector: "reverse-box-details",
  templateUrl: "./reverse-box-details.component.html",
  styleUrls: ["./reverse-box-details.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReverseBoxDetailsComponent implements OnInit {
  private _unsubscribeAll: Subject<any> = new Subject();
  @Input() singleBoxForm: FormGroup;
  @Input() boxList: any = [];

  searchText: string = undefined;
  singleBoxChangeSub: Subscription;
  weightConversionPipe = new WeightConversionPipe();

  constructor(
    private _cd: ChangeDetectorRef,
    private _boxesDataService: BoxesDataService
  ) {}

  ngOnInit(): void {
    this.handleSingleBoxChange();
    this.fetchBoxes();
  }

  markFormAsTouched() {
    this.singleBoxForm.markAsTouched();
    this._cd.markForCheck();
  }

  handleSingleBoxChange(): void {
    this.singleBoxChangeSub = this.singleBoxForm?.valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => {
        if (this.checkIfDimesionsChanged) this.resetBox();
      });
  }

  get checkIfDimesionsChanged(): boolean {
    const formGroup = this.singleBoxForm;
    const fieldsToCheck = ["weight", "length", "breadth", "height"];

    const changedFields = fieldsToCheck.filter(
      (field) => formGroup.get(field)?.dirty
    );

    return !!changedFields.length;
  }

  handleBoxChange({ value }) {
    if (!value) return;
    const selectedBox = findBox(value, this.boxList);
    this.patchDimensions(selectedBox || {});
  }

  // patch dimensions : weight, length, height, breadth
  patchDimensions(box: any): void {
    const newDimensions = {
      weight: this.weightConversionPipe.transform(box.weight, "kg"),
      length: box.length,
      breadth: box.breadth,
      height: box.height
    };

    this.singleBoxForm.patchValue(newDimensions);
    this.singleBoxForm.markAsPristine();
  }

  resetBox(): void {
    const boxFc = this.singleBoxForm.get("box");
    boxFc.reset("", { emitEvent: false });
  }

  ngOnDestroy(): void {
    this.singleBoxChangeSub.unsubscribe();
  }

  fetchBoxes(): void {
    let apiCalled = false;

    this._boxesDataService.boxes
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((boxesData) => {
        if (boxesData.length || apiCalled) {
          this.boxList = boxesData;
        } else if (!apiCalled) {
          apiCalled = true;
          this._boxesDataService.getBoxes(false);
        }
      });
  }
}
